// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"281":"02ab18fd98915a18","858":"5946da40ceb1720f","904":"c60e363d40870ef5"}[chunkId] + ".js";
};